import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'app/base/base.component';
import { TransactionStateHistory } from 'app/core/models/transactionStateHistory';
import { PaymentTransaction } from 'app/core/models/paymentTransaction';
import { PaymentTransactionStatusHistory } from 'app/core/models/paymentTransactionStatusHistory';
import { Transaction } from 'app/core/models/transaction';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { PaymentTransactionsService } from 'app/core/services/payment-transactions.service';
import { Observable } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.css']
})
export class TransactionDetailsComponent extends BaseComponent implements OnInit {

  @Input()
  transaction: Transaction;

  @Input()
  merchantName: string;

  @Input()
  supplierName: string;

  paymentTransaction : PaymentTransaction;

  constructor(public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private paymentTransactionService : PaymentTransactionsService,
    router: Router) {
    super(router);
  }

  ngOnInit() {
  }

  cancel() {
    this.activeModal.close();
  }

   bool = true;
   isLoading = true;
  goToPaymentTransaction(id : string) {
    this.paymentTransaction = new PaymentTransaction();
    this.paymentTransaction.id = id;
     this.bool = false;
     this.paymentTransactionService.getPaymentTransactionById(this.paymentTransaction.id).subscribe( val => {
     this.paymentTransaction = val ;
     this.isLoading = false ;
     })
   }

  date() {
    let frDateFormat = "dd MMM y, H:mm";
    let usDateFormat = "MMM dd y, hh:mm a";
    if (this.translate.currentLang == "fr_FR")
      return frDateFormat;
    else
      return usDateFormat;
  }

  locale() {
    if (this.translate.currentLang == "fr_FR")
      return "fr_FR";
    else
      return "en_US";
  }

  sortedHistory(): Array<TransactionStateHistory> {
    return this.transaction.transactionStateHistory.sort((a: TransactionStateHistory, b: TransactionStateHistory) => {
      return Date.parse(b.createdDate) - Date.parse(a.createdDate);
    });
  }

  sortedHistoryPayment(): Array<PaymentTransactionStatusHistory> {
    return this.paymentTransaction.paymentTransactionStatusHistory.sort((a: PaymentTransactionStatusHistory, b: PaymentTransactionStatusHistory) => {
      return Date.parse(b.createdDate) - Date.parse(a.createdDate);
    });
  }

  back() {
   this.bool = true;
   this.isLoading = true;
  }

  getDataSentValue(): String {
    if (this.transaction.dataSent == true)
      return "YES";
    else
      return "NO";
  }

  getLiabilityShift(liabilityShift: Boolean): String{
    if(liabilityShift){
      return "YES";
    }else{
      return "NO";
    }
  }
}
